module.exports = __webpack_public_path__ + "static/media/home-lg.b17eb427.svg";